<script setup>
import ClientInfo from './ClientInfo.vue'
import {computed, ref} from 'vue'
import {useI18n} from "vue-i18n";
import {computeClass} from "@/utils/styleFormats.js";
import BaseTable from "@/components/tables/BaseTable.vue";
import {IXCCustomerEntity} from "@/entities/IXCCustomerEntity.js";
import {getPerson} from "@/services/api/person.js";
import {handleError} from "@/utils/errors.js";
import {useTablePagination} from "@/js/composables/useTablePagination.js";
import {dateFormatterInput} from "@/utils/dateTimeFormat.js";

const props = defineProps({
    client: {
        type: Object,
        required: true
    },
    history: {
        type: Array,
        required: true
    },
    listContracts: {
        type: Array,
        required: true
    }
})

const { t } = useI18n();
const showHistoryModal = ref(false)
const ixcContractsEntity = new IXCCustomerEntity();
const entity = ref(ixcContractsEntity);
const loading = ref(false);
const historyItems = ref([])
const emit = defineEmits(['update:contract']);

const openClientHistory = () => {
    historyItems.value = (props.client?.historicos || []).map(item => ({
        ...item,
        data_historico: item.data_historico
            ? dateFormatterInput(item.data_historico)
            : item.data_historico
    }));

    showHistoryModal.value = true;
};

const openContractHistory = () => {
    historyItems.value = (props.history || []).map(item => ({
        ...item,
        data_historico: item.data_historico
            ? dateFormatterInput(item.data_historico)
            : item.data_historico
    }));

    showHistoryModal.value = true;
};


const {
    paginatedItems: paginatedHistory,
    totalInfo: totalHistory,
    currentPage: currentPageHistory,
    itemsPerPage: itemsPerPageHistory,
    onPageChange: onPageChangeHistory
} = useTablePagination({
    items: historyItems,
    page: 1,
    perPage: 10
})

function handleContractUpdate(contract) {
    emit('update:contract', contract);
}

</script>

<template>
    <div class="card">
        <div class="left">
            <img
                class="avatar"
                src="https://cdn-icons-png.flaticon.com/512/219/219988.png"
            />
            <ClientInfo :client="client"
                        :listContracts="listContracts"
                        @update:contract="handleContractUpdate"
            />
        </div>

        <div class="actions">
            <div class="meta ga-2">
                <button class="btn color-primary border" @click="openClientHistory">
                    <v-icon>mdi-account</v-icon>
                    {{ t("components.customers.index.clientHistory") }}
                </button>

                <button class="btn primary" @click="openContractHistory">
                    <v-icon>mdi-history</v-icon>
                    {{ t("components.customers.index.contractHistory") }}
                </button>
            </div>
        </div>
    </div>

    <v-dialog v-model="showHistoryModal" :max-width="1000" >
        <div class="create-dialog-box border-radius d-block bg-white border-0 shadow-none">
            <div class="title d-flex align-items-center justify-space-between">
                <h5 class="mb-0">{{ t("components.customers.index.history") }}</h5>
                <button class="close-btn bg-transparent p-0 border-none" @click="showHistoryModal = false">
                    <i class="ri-close-fill"></i>
                </button>
            </div>
            <v-card class="bg-white">
                <BaseTable
                    :fetchData="null"
                    :entity="entity"
                    :items="paginatedHistory"
                    :loading="loading"
                    :totalItems="totalHistory"
                    :currentPage="currentPageHistory"
                    :itemsPerPage="itemsPerPageHistory"
                    :actions="null"
                    tableToUse="historyTable"
                    @page-change="onPageChangeHistory"
                >
                </BaseTable>
                <v-card-actions>
                    <v-spacer />
                    <template>
                        <v-btn text @click="close">{{ t("common.labels.cancel") }}</v-btn>
                    </template>
                </v-card-actions>
            </v-card>
        </div>
    </v-dialog>

</template>
<style scoped>

.btn {
    border: none;
    padding: 8px 14px;
    border-radius: 8px;
    font-size: 14px;
    cursor: pointer;
}

.btn.primary {
    background: #6366f1;
    color: white;
}

.btn.color-primary {
    color:  #6366f1;
}

.dark-theme .btn.color-primary {
    border-color:  #6366f1!important;
}

.meta {
    margin-top: 6px;
    font-size: 13px;
    color: #6b7280;
    display: flex;
    gap: 16px;
}
.card {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 20px;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    background: #ffffff;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.left {
    display: flex;
    align-items: center;
    gap: 16px;
}

.avatar {
    width: 56px;
    height: 56px;
    border-radius: 10px;
    object-fit: cover;
    background: #f3f4f6;
}

.actions {
    display: flex;
    gap: 12px;
}

@media (max-width: 768px) {
    .card {
        flex-direction: column;
        align-items: flex-start;
        gap: 12px;
    }

    .left {
        width: 100%;
    }

    .actions {
        width: 100%;
    }

    .meta {
        width: 100%;
        justify-content: flex-start;
    }
}

</style>
